import { createSlice } from '@reduxjs/toolkit'

const sliceName = 'routingFormsIndexPage'

const initialState = {
  deletedForm: null,
  clonedForm: null,
  renamedForm: null,
  isExportPopupOpen: false
}

const slice = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    setDeletedForm(state, { payload }) {
      state.deletedForm = payload
    },
    setClonedForm(state, { payload }) {
      state.clonedForm = payload
    },
    setRenamedForm(state, { payload }) {
      state.renamedForm = payload
    },
    setIsExportPopupOpen(state, { payload }) {
      state.isExportPopupOpen = payload
    }
  }
})

export const {
  actions: {
    setDeletedForm,
    setClonedForm,
    setIsExportPopupOpen,
    setRenamedForm
  }
} = slice

export const reducerObject = { [sliceName]: slice.reducer }
